/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlHoliday = "/master/holidays";
const urlHolidayDeleteMultiple = "/master/holidays/delete-multiple";

const state = {
  holidays: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * Get list holidays
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListHolidays({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlHoliday}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_HOLIDAYS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Create holiday
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post(urlHoliday, payload);
  },

  /**
   * Update holiday
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return await axios.put(`${urlHoliday}/${id}`, payload);
  },

  /**
   * Delete holiday
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`${urlHoliday}/${id}`);
  },

  /**
   * delete multiple holiday
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlHolidayDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_HOLIDAYS(state, data) {
    state.holidays = data.items;
    state.pagination = data.pagination;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
